export class InvalidRefreshTokenError extends Error {
  constructor() {
    super();
    this.name = 'InvalidRefreshTokenError';
    Object.setPrototypeOf(this, InvalidRefreshTokenError.prototype);
  }
}
